export const siteApplicationsKeys = {
  all: ['site', 'applications'] as const,
  lists: () => [...siteApplicationsKeys.all, 'list'] as const,
  list: (siteToken: string) =>
    [...siteApplicationsKeys.lists(), siteToken] as const,
  details: () => [...siteApplicationsKeys.all, 'detail'] as const,
  detail: (applicationToken: string) =>
    [...siteApplicationsKeys.details(), applicationToken] as const,
};
